var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrize1 = function SvgPrize1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.915,
    height: 31.593
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prize-1_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfa244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#605122"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u7EC4 7829"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19244",
    d: "M491.66 508.9v26.307l12.958 5.286 12.958-5.286V508.9Z",
    transform: "translate(-491.659 -508.904)",
    fill: "url(#prize-1_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19245",
    d: "m12.844 28.281-.089-.038-9.9-4.189V3.118h19.98v20.933Zm-9.533-4.53 9.534 4.033 9.532-4.033V3.575H3.311Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19247",
    d: "M10.662 10.016V7.929h3.9v11.792h-2.331v-9.705Z",
    fill: "#fff"
  }))));
};
export default SvgPrize1;